import { register } from './register'

const REGISTRATION_REQUEST_TIMEOUT = 3000
let attempts = 0

export const onRegistrationFailed = () => {
  attempts++
  setTimeout(() => register(), attempts * REGISTRATION_REQUEST_TIMEOUT)
}
